import { ORGANIZATIONS_API, ORGANIZATIONS_NI_API, SUBCATEGORY_NI_API } from "../../../Utilities/APIs";
import PcSSCRUD from "../../Partials/Layouts/CRUDs/CRUDLayouts/SSCRUD/PcSSCRUD";

function OrganizationNICards() {
  return (
    <PcSSCRUD
        // parentChild props
        parentDBField={'organization'}
        
        // common props
        api={ORGANIZATIONS_NI_API}
        screenTopicSingular={'Organization NI Card'}
        screenTopicPlural={'Organization NI Cards'}
        
        // crud header props
        showTotalInHeading
        
        // crud props
        allowCreate
        allowUpdate
        allowDelete
        
        // select props
        selectApi={ORGANIZATIONS_API}
        selectType={'parent-child'}
        selectDBField={'organization'}
        selectName={'Organization'}

        // second select props
        secondSelectApi={SUBCATEGORY_NI_API}
        secondSelectType={'parent-child'}
        secondSelectDBField={'subcatNICard'}
        secondSelectName={'Subcategory NI'}
    />
  )
}

export default OrganizationNICards